export default "__VITE_ASSET__CQ_baW_X__"